import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import useIsMobile from '../../Utils/customHooks/useIsMobile';
import { ListThumbnail } from '../ListThumbnail';
import { ListTitle } from '../ListTitle';
import moduleStyles from '@dtsl/css-list/dist/index.module.css';
function ListTitleBlock(props) {
  const {
    titleInfo,
    thumbnail
  } = props;
  const {
    isMobile: isMobileView
  } = useIsMobile(640);
  const listTitleThumbnailClasses = classNames({
    [moduleStyles['sib-list__title-block']]: true,
    [moduleStyles['sib-list__title-block-xs']]: isMobileView
  });
  return /*#__PURE__*/React.createElement("div", {
    className: listTitleThumbnailClasses
  }, /*#__PURE__*/React.createElement(ListThumbnail, thumbnail), /*#__PURE__*/React.createElement(ListTitle, titleInfo));
}
ListTitleBlock.propTypes = {
  titleInfo: PropTypes.shape({
    titleUrl: PropTypes.string,
    title: PropTypes.string,
    titleInfo: PropTypes.node
  }),
  thumbnail: PropTypes.shape({
    image: PropTypes.string,
    imageMetaData: PropTypes.shape({}),
    url: PropTypes.string,
    hoverText: PropTypes.string
  })
};
export default ListTitleBlock;